export default "__VITE_ASSET__CZA4LoLe__"